import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { brandInfo, contactInfo } from '../data/mock';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#inicio', label: 'Início' },
    { href: '#servicos', label: 'Serviços' },
    { href: '#promocoes', label: 'Promoções' },
    { href: '#produtos', label: 'Mary Kay' },
    { href: '#sobre', label: 'Sobre' },
    { href: '#contactos', label: 'Contactos' },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-[#0a0a0a]/95 backdrop-blur-md shadow-lg shadow-black/20'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#inicio" className="flex-shrink-0" onClick={(e) => scrollToSection(e, '#inicio')}>
            <img
              src={brandInfo.logo}
              alt={brandInfo.name}
              className="h-14 w-auto object-contain"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="nav-link text-sm font-medium tracking-wide uppercase"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <a href={`tel:${contactInfo.phone}`} className="flex items-center text-[#E1C57C] hover:text-[#FADCD9] transition-colors">
              <Phone size={16} className="mr-2" />
              <span className="text-sm">{contactInfo.phone}</span>
            </a>
            <Button
              onClick={(e) => scrollToSection(e, '#marcacoes')}
              className="btn-gold px-6 py-2 rounded-none font-medium text-sm tracking-wide"
            >
              MARCAR
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#E1C57C] p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-[#0a0a0a]/98 backdrop-blur-md border-t border-[#C1A54F]/20 px-4 py-6">
          <nav className="flex flex-col space-y-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="text-[#f5f0e8] hover:text-[#E1C57C] text-lg font-medium py-2 border-b border-[#C1A54F]/10"
              >
                {link.label}
              </a>
            ))}
            <Button
              onClick={(e) => scrollToSection(e, '#marcacoes')}
              className="btn-gold w-full py-3 rounded-none font-medium tracking-wide mt-4"
            >
              MARCAR AGORA
            </Button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
